<template>
  <div :class="cn(['text-error text-sm py-1 text-left'])"><slot /></div>
</template>
